import { useState } from 'react'
import {
  Button,
  Heading,
  Text,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Tooltip,
  Box,
} from '@chakra-ui/react'

import { Trash } from 'components/icons'
import { IconButtonWithPermission } from 'components'
import { CustomFormQuestion } from '../../../../../../../../types'
import { useCustomFormBuilder } from '../../../../../../contexts/CustomFormBuilderManagerContext/Provider'

type QuestionProps = {
  question: CustomFormQuestion
}

export default function CustomFormBuilderDeleteQuestionButton({ question }: QuestionProps) {
  const [loadingButton, setLoadingButton] = useState(false)

  const { isOpen, onClose, onOpen } = useDisclosure()
  const { isFormActionsDisabled, permissions, deleteQuestion } = useCustomFormBuilder()

  async function onDelete() {
    setLoadingButton(true)
    const response = await deleteQuestion(question?.id || '0')
    if (response) onClose()
    setLoadingButton(false)
  }

  if (isFormActionsDisabled) {
    return (
      <Tooltip label="Este formulário é protegido, não pode ser alterado / deletado">
        <Box>
          <IconButtonWithPermission
            isDisabled={isFormActionsDisabled}
            icon={<Trash />}
            aria-label="icon"
            variant="ghost"
            size="sm"
            colorScheme="red"
          />
        </Box>
      </Tooltip>
    )
  }

  return (
    <>
      <IconButtonWithPermission
        customDisableCondition={permissions?.deleteFormQuestion}
        icon={<Trash />}
        aria-label="icon"
        variant="ghost"
        size="sm"
        colorScheme="red"
        onClick={onOpen}
      />

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />

        <ModalContent>
          <ModalCloseButton />
          <ModalHeader>
            <Heading>Deseja deletar a questão?</Heading>
          </ModalHeader>

          <ModalBody>
            <Text>Uma vez que a questão seja deletada, você não terá mais acesso a mesma</Text>
          </ModalBody>

          <ModalFooter>
            <Button onClick={onClose} variant="ghost">
              Cancelar
            </Button>
            <Button isLoading={loadingButton} onClick={() => onDelete()} colorScheme="red">
              Sim, tenho certeza
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}
